import { RouteComponentProps } from 'react-router'
import { AgreementsTableStore, AGREEMENTS_TABLE_STORE } from 'store'

export type AgreementsPageProps = RouteComponentProps & {
  [AGREEMENTS_TABLE_STORE]?: AgreementsTableStore
}

// export const agreementsTableWidths = {
//   agreements: 21,
//   stores: 15,
//   projects: 15,
//   products: 10,
//   budget: 15,
//   period: 12,
//   status: 12
// }

export const agreementsTableWidths = {
  agreements: 300,
  stores: 300,
  projects: 300,
  products: 225,
  budget: 200,
  period: 280,
  status: 200
}
